export const DISPLAY_FOOTER = 'DISPLAY_FOOTER';

export function changeDisplayFooter(bool){
    return {type: DISPLAY_FOOTER, payload: bool};
}